import { object, string, number } from 'yup';
import { REGEX_VALID_CUSTOMFIELD_ID, __yupValidatonErrorToCCError } from './model/dto-validators';
import { StoragePermissionDTOUserOrGroup, returnNoErrorWithPayload, returnErrorWithEmptyPayload, } from './model/model';
export const REGEX_VALID_ACCOUNT_ID_OR_GROUP_ID = /^[-:_.a-zA-Z0-9]+$/;
export const computeFieldPermissionStorageKey = (fieldId, contextId) => {
    if (contextId === null) {
        return `fpermv1#${fieldId}#global#`;
    }
    else {
        return `fpermv1#${fieldId}#${contextId}#`;
    }
};
export const computeUserOrGroupStorageKey = (userOrGroup, type) => {
    if (type === StoragePermissionDTOUserOrGroup.USER) {
        return `upermv1#${userOrGroup}#`;
    }
    else {
        return `gpermv1#${userOrGroup}#`;
    }
};
export const enforceValid_StoragePermissionDTOPatchGroupPermissions = async (perm) => {
    const schema = object({
        groupId: string().required().matches(REGEX_VALID_ACCOUNT_ID_OR_GROUP_ID, 'invalid groupId format'),
        permission: object({
            fieldId: string().required().matches(REGEX_VALID_CUSTOMFIELD_ID, 'invalid fieldId format'),
            contextId: number().positive().integer().nullable().defined(),
        }).noUnknown(true),
        type: string().required().oneOf(['ADD', 'DELETE']),
    }).noUnknown(true);
    try {
        await schema.validate(perm, { strict: true });
        return returnNoErrorWithPayload(null);
    }
    catch (err) {
        return returnErrorWithEmptyPayload(__yupValidatonErrorToCCError(err));
    }
};
export const enforceValid_StoragePermissionDTOPatchUserPermissions = async (perm) => {
    const schema = object({
        userAccountId: string().required().matches(REGEX_VALID_ACCOUNT_ID_OR_GROUP_ID, 'invalid userAccountId format'),
        permission: object({
            fieldId: string().required().matches(REGEX_VALID_CUSTOMFIELD_ID, 'invalid fieldId format'),
            contextId: number().positive().integer().nullable().defined(),
        }).noUnknown(true),
        type: string().required().oneOf(['ADD', 'DELETE']),
    }).noUnknown(true);
    try {
        await schema.validate(perm, { strict: true });
        return returnNoErrorWithPayload(null);
    }
    catch (err) {
        return returnErrorWithEmptyPayload(__yupValidatonErrorToCCError(err));
    }
};
export const doesUserOrGroupPermissionAlreadyExist = (permissions, fieldId, contextId) => {
    const foundIndex = permissions.findIndex((ep) => ep.contextId === contextId && ep.fieldId === fieldId);
    return { doesAlreadyExist: foundIndex !== -1, index: foundIndex };
};
export const removePermissionFromExistingAndDoNotFailOnNotExisting = (permissions, fieldId, contextId) => {
    const existsAndIndex = doesUserOrGroupPermissionAlreadyExist(permissions, fieldId, contextId);
    if (existsAndIndex.doesAlreadyExist) {
        const newPermissions = [...permissions];
        newPermissions.splice(existsAndIndex.index, 1);
        return newPermissions;
    }
    else {
        return permissions; // do nothing if not exists
    }
};
